import { Skeleton } from "@/app/components/shadcn/skeleton";

const UserMenuItemsSkeleton = () => {
  return (
    <div className="space-y-1">
      {Array.from({ length: 5 }).map((_, index) => (
        <div
          key={index}
          className="flex items-center gap-3 px-3 py-2 rounded-lg"
        >
          <Skeleton className="w-4 h-4 rounded shrink-0" />
          <Skeleton className="h-4 flex-1 max-w-32" />
          {index === 2 && <Skeleton className="h-5 w-8 rounded-full" />}
        </div>
      ))}
    </div>
  );
};

export default UserMenuItemsSkeleton;